import React, { Component } from "react";
import logo2 from "../assets/logo2.png";

class SeminarChiangmai2 extends Component {
  state = { registered: {} };
  seminar = "chiangmai"; // ✅ Unique seminar identifier

  componentDidMount() {
    this.fetchRegistered();
  }

  fetchRegistered = async () => {
    try {
      const res = await fetch(`/api/registered?seminar=${this.seminar}`);
      const data = await res.json();
      this.setState({ registered: data });
    } catch (err) {
      console.error("Failed to fetch registered list:", err);
    }
  };

  handleRegister = async (id) => {
    const isRegistered = this.state.registered[id];

    if (isRegistered) {
      const pin = window.prompt("Enter PIN to unregister:");
      const res = await fetch("/api/unregister", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ seminar: this.seminar, id, pin }),
      });

      if (res.ok) {
        const data = await res.json();
        this.setState({ registered: data });
        alert("Unregistered successfully.");
      } else {
        alert("Incorrect PIN. Unregister cancelled.");
      }
    } else {
      const confirmRegister = window.confirm("Do you want to register?");
      if (confirmRegister) {
        const res = await fetch("/api/register", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ seminar: this.seminar, id }),
        });
        const data = await res.json();
        this.setState({ registered: data });
      }
    }
  };

  renderParticipant = (id, name) => {
    const isRegistered = this.state.registered[id];
    return (
      <div key={id}>
        <span
          onClick={() => this.handleRegister(id)}
          style={{
            color: isRegistered ? "red" : "blue", // keep original blue default
            cursor: "pointer",
            fontWeight: "500",
          }}
        >
          {id}. {name}
        </span>
      </div>
    );
  };

  render() {
    return (
      <div className="AllClasses">
        <h3>Aikido Chiangmai Participants Day 2</h3>
        <br /><br />

        {this.renderParticipant(1, "รักชนก​ ชยุตม์กุล")}
        <br />
        {this.renderParticipant(2, "ธีระรัตน์ บริพันธกุล")}
        <br />
        {this.renderParticipant(3, "พันตรี กิตติศักดิ์ ศิริภาพ")}
        <br />
        {this.renderParticipant(4, "Ms.Siriphorn Manokeaw")}
        <br />
        {this.renderParticipant(5, "นายพิพัฒน์พงษ์ วงศ์ใหญ่")}
        <br />
        {this.renderParticipant(6, "นายชูชีพ สุนทรานนท์")}
        <br />
        {this.renderParticipant(7, "นายเฟื่องวิชญ์ มณีกาญจน์")}
        <br />
        {this.renderParticipant(8, "Mr.Ping Roekphisut")}
        <br />
        {this.renderParticipant(9, "Ms.Narumon Thammapruksa")}
        <br />

        <div>ASEAN AIKIDO FELLOWSHIP SEMINAR 2025 REGISTRATION SYSTEM...</div>
        <br /><br />
        <div>Powered by</div>
        <img className="logo2" src={logo2} alt="logo" />
        <div>New Wave Consulting Group</div>
      </div>
    );
  }
}

export default SeminarChiangmai2;
